import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Layout } from "@/components/Layout";
import { UpdateNotifier } from "@/components/UpdateNotifier";
import Dashboard from "@/pages/Dashboard";
import Events from "@/pages/Events";
import Accounting from "@/pages/Accounting";
import Entrate from "@/pages/Entrate";
import Uscite from "@/pages/Uscite";
import Staff from "@/pages/Staff";
import Inventory from "@/pages/Inventory";
import AIPartner from "@/pages/AIPartner";
import Vehicles from "@/pages/Vehicles";
import Reports from "@/pages/Reports";
import Ranking from "@/pages/Ranking";
import Rimborsi from "@/pages/Rimborsi";
import Accessi from "@/pages/Accessi";
import Timbrature from "@/pages/Timbrature";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import StaffHome from "@/pages/StaffHome";

function AdminApp() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/eventi" element={<Events />} />
        <Route path="/entrate" element={<Entrate />} />
        <Route path="/uscite" element={<Uscite />} />
        <Route path="/contabilita" element={<Accounting />} />
        <Route path="/personale" element={<Staff />} />
        <Route path="/timbrature" element={<Timbrature />} />
        <Route path="/magazzino" element={<Inventory />} />
        <Route path="/veicoli" element={<Vehicles />} />
        <Route path="/report" element={<Reports />} />
        <Route path="/classifica" element={<Ranking />} />
        <Route path="/rimborsi" element={<Rimborsi />} />
        <Route path="/accessi" element={<Accessi />} />
        <Route path="/socio" element={<AIPartner />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function Gate() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-[#090D14] flex items-center justify-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <StaffHome />;
  return <AdminApp />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/*" element={<Gate />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" richColors />
        <UpdateNotifier />
      </AuthProvider>
    </div>
  );
}

export default App;
